import { render, staticRenderFns } from "./state-head.vue?vue&type=template&id=1d50d0d4"
import script from "./state-head.vue?vue&type=script&lang=js"
export * from "./state-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports